import { LinkService } from 'src/app/services/general/link.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user/user.service';
import { User } from 'src/app/interfaces/user';

@Component({
  selector: 'app-help',
  templateUrl: './help.page.html',
  styleUrls: ['./help.page.scss'],
})
export class HelpPage implements OnInit, OnDestroy {

  /**
   * Show Menu Btn
   */
  showMenuBtn: boolean;
  /**
   * User Subscription
   */
  private userSubscription: Subscription;

    constructor(
    private router: Router,
    private userService: UserService,
    private linkService: LinkService,
  ) { }

  ngOnInit() {
  }

  ngOnDestroy(): void {
      this.unwatchUser();
  }

  ionViewWillEnter() {
    this.watchUser();
  }

  ionViewWillLeave() {
    this.unwatchUser();
  }

  /**
   * Watch user
   */
  async watchUser() {
    if (!this.userSubscription) {
      this.userSubscription = this.userService.observableUser.subscribe((user: User) => {
        if (user?.uid) {
          this.showMenuBtn = true;
        }
      });
    }
  }

  /**
   * Unwatch user
   */
  async unwatchUser() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
      this.userSubscription = null;
    }
  }

  /**
   * Go main page
   */
  goMainPage() {
    this.linkService.goMainPage();
  }

  goContactPage() {
    const navigationExtras: NavigationExtras = {
      state: { backHelpPage: true }
    };
    this.router.navigate(['/about/contact'], navigationExtras);
  }

  goReferralPage() {
    const navigationExtras: NavigationExtras = {
      state: { backHelpPage: true }
    };
    this.router.navigate(['/user/referral'], navigationExtras);
  }

  goPrivacyPage() {
    const navigationExtras: NavigationExtras = {
      state: { backHelpPage: true }
    };
    this.router.navigate(['/about/privacy'], navigationExtras);
  }

  goTermPage() {
    const navigationExtras: NavigationExtras = {
      state: { backHelpPage: true }
    };
    this.router.navigate(['/about/term'], navigationExtras);
  }

  goAupPage() {
    const navigationExtras: NavigationExtras = {
      state: { backHelpPage: true }
    };
    this.router.navigate(['/about/aup'], navigationExtras);
  }

  goAppDownloadPage() {
    this.linkService.goAppDownloadPage(true, true);
  }

  goAppUpdatePage() {
    const navigationExtras: NavigationExtras = {
      state: { backHelpPage: true }
    };
    this.router.navigate(['/about/app-update'], navigationExtras);
  }

  goAppRatingPage() {
    const navigationExtras: NavigationExtras = {
      state: { backHelpPage: true, showPage: true }
    };
    this.router.navigate(['/about/app-rating/true'], navigationExtras);
  }

  openHelpCenter() {
    this.linkService.goHelpCenter();
  }

  openWebsite() {
    this.linkService.goWebsite();
  }

}
